enum ActionType {
    REQUEST_CONFIG = '[CORE/CONFIG] GET CONFIG',
    RECEIVE_CONFIG = '[CORE/CONFIG] SET CONFIG',
    SHOW_BETA_PAGE = '[CORE/CONFIG] SHOW BETA PAGE',
    CONFIG_ERROR = '[CORE/CONFIG] CONFIG ERROR',
}

export default ActionType
